/*
 * gramms LP — Reveal on scroll
 *
 * Deals the children of any [data-lp1-reveal] list into view, staggered.
 * Paired with lp1-reveal.css. See that file for the tuning properties.
 *
 * Ported from bello-repo-main (assets/bello-reveal.js).
 *
 * Several sections on each landing load this asset, so the file is guarded:
 * the work runs once no matter how many <script> tags point here.
 */
(function () {
  'use strict';

  if (window.__lp1Reveal) return;
  window.__lp1Reveal = true;

  var ARMED = 'lp1-reveal-armed';
  var IN = 'lp1-reveal-in';
  var SELF = 'lp1-reveal-self';

  /*
   * A list deals its children in. A photo has no children to deal — it is the
   * thing that should move — and it is a sibling of the copy column, not a
   * child of it, so it cannot ride along. data-lp1-reveal="self" animates the
   * marked element itself, which is what lets an image sit next to an already
   * animating column without nesting one reveal inside another.
   */
  function targets(list) {
    if (list.getAttribute('data-lp1-reveal') === 'self') return [list];
    return Array.prototype.slice.call(list.children);
  }

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /*
   * Strips every trace of the reveal once the last card has settled. The armed
   * rule sets `transition` on each card, which would otherwise replace whatever
   * transition that card already had of its own — the FAQ item, for one,
   * animates its border colour when it opens. Cleaning up hands each section
   * its own styles back, and the cards are already at their final values, so
   * nothing moves.
   */
  function disarm(list) {
    list.classList.remove(ARMED);
    var cards = targets(list);
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.remove(IN);
      cards[i].style.removeProperty('--lp1-reveal-index');
      cards[i].style.removeProperty('opacity');
      cards[i].style.removeProperty('translate');
      cards[i].style.removeProperty('scale');
      cards[i].style.removeProperty('rotate');
      delete cards[i].__lp1RestingOpacity;
      if (!cards[i].getAttribute('style')) cards[i].removeAttribute('style');
    }
    list.classList.remove(SELF);
  }

  function land(list) {
    var cards = targets(list);
    for (var i = 0; i < cards.length; i++) {
      cards[i].classList.add(IN);
      cards[i].style.opacity = cards[i].__lp1RestingOpacity || '1';
    }

    var last = cards[cards.length - 1];
    if (!last) return;

    // Read the real values rather than assuming the defaults, so a section that
    // overrides the timing still gets cleaned up at the right moment.
    var style = window.getComputedStyle(last);
    var seconds = function (value) {
      return parseFloat(String(value).split(',')[0]) || 0;
    };
    var total = (seconds(style.transitionDelay) + seconds(style.transitionDuration)) * 1000;

    setTimeout(function () {
      disarm(list);
    }, total + 60);
  }

  function arm(list) {
    if (list.__lp1RevealArmed) return;
    list.__lp1RevealArmed = true;

    // Someone who wants less motion gets the finished layout, never a hidden one.
    if (reduced && reduced.matches) return;

    /*
     * Nada que ya este en pantalla al abrir la pagina se anima.
     *
     * Un reveal es una reaccion al scroll. Reproducirlo en el hero hace que el
     * visitante vea esconderse y volver justo lo que ya estaba mirando, que se
     * lee como un fallo — y si el navegador alcanzo a pintar antes de que este
     * script corriera, como un parpadeo. Debajo del pliegue no hay nada que
     * parpadear, asi que la regla solo cuesta la animacion del primer golpe de
     * vista, que es precisamente la que sobra.
     */
    var rect = list.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < viewport && rect.bottom > 0) return;

    // Index drives the stagger. Set before arming so the first paint after the
    // cards are hidden already carries each card's delay.
    var cards = targets(list);
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.setProperty('--lp1-reveal-index', i);

      // Remember where the card is meant to end up before hiding it. Lists that
      // dim their own rows must land back on that value, not on a flat 1.
      cards[i].__lp1RestingOpacity = window.getComputedStyle(cards[i]).opacity;
      cards[i].style.opacity = '0';
    }

    list.classList.add(ARMED);
    if (list.getAttribute('data-lp1-reveal') === 'self') list.classList.add(SELF);

    if (!('IntersectionObserver' in window)) {
      land(list);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          land(entry.target);
        });
      },
      {
        // Starts once a sliver of the list has cleared the fold, so the first
        // card is already moving by the time the reader looks at it.
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.01,
      }
    );

    observer.observe(list);
  }

  function scan(root) {
    var lists = (root || document).querySelectorAll('[data-lp1-reveal]');
    for (var i = 0; i < lists.length; i++) arm(lists[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  // A section re-rendered in the theme editor arrives with its cards hidden
  // and no observer watching them.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
